import { createFileRoute } from "@tanstack/react-router";
import TennisverenigingAppSpelers from "@/pages/TennisverenigingAppSpelers";

export const Route = createFileRoute("/tennisvereniging-app-spelers")({
  head: () => ({
    meta: [
      { title: "Tennisvereniging app voor spelers — aanmelden, indeling & meldingen | De Hussel App" },
      { name: "description", content: "Een app voor jouw tennisvereniging waar spelers zich aanmelden, hun indeling zien en push-meldingen krijgen. Zonder installatie, werkt op iedere telefoon." },
      { property: "og:title", content: "Tennisvereniging app voor spelers — aanmelden, indeling & meldingen | De Hussel App" },
      { property: "og:description", content: "Een app voor jouw tennisvereniging waar spelers zich aanmelden, hun indeling zien en push-meldingen krijgen. Zonder installatie, werkt op iedere telefoon." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://dehusselapp.nl/tennisvereniging-app-spelers" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://dehusselapp.nl/tennisvereniging-app-spelers" }],
  }),
  component: TennisverenigingAppSpelers,
});
